/**
 * Module NEUTRE « testimonials » — KEEP IN SYNC avec
 * inventozen-frontpublic/src/cms-puck/testimonials.ts
 */
export type TestimonialItem = {
  quote: string;
  author: string;
  role: string;
  imageAttachmentId: string;
};

export type TestimonialsLayout = "grid" | "carousel";

export function normalizeTestimonialItem(value: unknown): TestimonialItem {
  const o = (value ?? {}) as Partial<TestimonialItem>;
  return {
    quote: String(o.quote ?? "").trim(),
    author: String(o.author ?? "").trim(),
    role: String(o.role ?? "").trim(),
    imageAttachmentId: String(o.imageAttachmentId ?? "").trim(),
  };
}

export function normalizeTestimonialsLayout(value: unknown): TestimonialsLayout {
  return String(value ?? "") === "carousel" ? "carousel" : "grid";
}

/** Items non vides (citation requise). */
export function activeTestimonialItems(
  items: TestimonialItem[],
): TestimonialItem[] {
  return items.filter((it) => it.quote.length > 0);
}
